import { signOut } from "aws-amplify/auth";

export interface SignOutRedirectConfig {
  clientId: string;
  domain: string;
  redirectUri: string;
}

function getHostedUiOrigin(domain: string) {
  return domain.startsWith("http://") || domain.startsWith("https://")
    ? domain
    : `https://${domain}`;
}

export function redirectToHostedUiLogout(
  redirectConfig: SignOutRedirectConfig,
): void {
  const logoutUrl = new URL(
    "/logout",
    getHostedUiOrigin(redirectConfig.domain),
  );
  logoutUrl.searchParams.set("client_id", redirectConfig.clientId);
  logoutUrl.searchParams.set("logout_uri", redirectConfig.redirectUri);
  window.location.assign(logoutUrl.toString());
}

/**
 * Signs out of the current app client. When Hosted UI details are provided,
 * this also clears the Cognito session cookie and redirects the browser back
 * to the app. Keeping this sign-out scoped prevents a web sign-out from
 * revoking sessions held by other app clients, such as the mobile app.
 */
export async function signOutCurrentClient(
  redirectConfig?: SignOutRedirectConfig,
): Promise<void> {
  await signOut();

  if (
    typeof window === "undefined" ||
    !redirectConfig?.clientId ||
    !redirectConfig.domain ||
    !redirectConfig.redirectUri
  ) {
    return;
  }

  redirectToHostedUiLogout(redirectConfig);
}
